import colors from "../../base/colors";
import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";

import rgba from "../../functions/rgba";
import pxToRem from "../../functions/pxToRem";

const { white, text, muted_gold, dark_teal, navy, slate_gray, olive_green, soft_cream } = colors;
const { borderRadius } = borders;
const { colored } = boxShadows;

const chip = {
  styleOverrides: {
    root: {
      position: "relative",
      fontSize: "0.875rem",
      fontFamily: "inherit",
      minHeight: "unset",
      padding: "0.5rem 1rem",
      borderRadius: borderRadius.lg,
      textTransform: "none",
      fontWeight: 400,
      zIndex: 1,
      backgroundColor: navy.main,
      color: text.main,
      boxShadow: colored.navy,
      transition: "all 200ms linear",

      "&:hover": {
        boxShadow: colored.navy,
      },

      "& .MuiChip-label": {
        lineHeight: 1.25,
        padding: "0 0.5rem",
      },

      "& .MuiChip-deleteIcon": {
        margin: "0 0.2rem 0 -0.6rem",
        "&:hover": {
          color: text.main,
        },
      },
    },

    containedDarkTeal: {
      backgroundColor: dark_teal.main,
      color: white.main,
      boxShadow: colored.dark_teal,

      "&:hover": {
        boxShadow: colored.dark_teal,
      },
    },

    containedNavy: {
      backgroundColor: navy.main,
      color: white.main,
      boxShadow: colored.navy,

      "&:hover": {
        boxShadow: colored.navy,
      },
    },
    containedSlateGray: {
      backgroundColor: slate_gray.main,
      color: white.main,
      boxShadow: colored.slate_gray,

      "&:hover": {
        boxShadow: colored.slate_gray,
      },
    },

    containedOliveGreen: {
      backgroundColor: olive_green.main,
      color: white.main,
      boxShadow: colored.olive_green,

      "&:hover": {
        boxShadow: colored.olive_green,
      },
    },

    containedSoftCream: {
      backgroundColor: soft_cream.main,
      color: dark_teal.main,
      boxShadow: colored.soft_cream,

      "&:hover": {
        boxShadow: colored.soft_cream,
      },
    },

    outlined: {
      backgroundColor: "transparent",
      color: text.main,
      boxShadow: "none",
      border: `1px solid ${text.main}`,

      "&:hover": {
        boxShadow: "none",
      },
    },

    outlinedDarkTeal: {
      color: dark_teal.main,
      border: `1px solid ${dark_teal.main}`,
    },

    outlinedNavy: {
      color: navy.main,
      border: `1px solid ${navy.main}`,
    },

    outlinedSlateGray: {
      color: slate_gray.main,
      border: `1px solid ${slate_gray.main}`,
    },

    outlinedOliveGreen: {
      color: olive_green.main,
      border: `1px solid ${olive_green.main}`,
    },

    outlinedSoftCream: {
      color: soft_cream.main,
      border: `1px solid ${soft_cream.main}`,
    },

    // Chip with custom size
    sizeSmall: {
      height: pxToRem(24),
      fontSize: pxToRem(12),
      padding: `0 ${pxToRem(8)}`,
    },
    sizeMedium: {
      height: pxToRem(32),
      fontSize: pxToRem(14),
      padding: `0 ${pxToRem(12)}`,
    },
    sizeLarge: {
      height: pxToRem(40),
      fontSize: pxToRem(16),
      padding: `0 ${pxToRem(16)}`,
    },

    // Chip with custom icon
    icon: {
      marginRight: pxToRem(4),
      fontSize: pxToRem(16),
    },
    deleteIcon: {
      marginLeft: pxToRem(4),
      fontSize: pxToRem(16),
      color: rgba(white.main, 0.7),
      "&:hover": {
        color: white.main,
      },
    },
  },
};

export default chip; 